/**
 * Identifies this running app instance (tab / window) to the dialing-session
 * claim endpoint. The backend echoes it back on the `DIALING_SESSION_CLAIMED`
 * WebSocket event so every client can tell whether it was the claimer.
 * Deliberately not persisted — two tabs must never share an id.
 */
export const DIALING_SESSION_CLIENT_ID = crypto.randomUUID();

export type DialingSessionClaimedEvent = {
  sessionId?: string;
  clientId?: string;
};

type Listener = (event: DialingSessionClaimedEvent) => void;

const listeners = new Set<Listener>();

/** Subscribe to `DIALING_SESSION_CLAIMED` WebSocket events. Returns an unsubscribe. */
export const onDialingSessionClaimed = (listener: Listener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const emitDialingSessionClaimed = (event: DialingSessionClaimedEvent) => {
  for (const listener of listeners) {
    listener(event);
  }
};
